import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const SyncPaymentMethodFromStripeMutation = graphql.persisted(
  "SyncPaymentMethodFromStripe",
  graphql(`
    mutation SyncPaymentMethodFromStripe($input: SyncPaymentMethodFromStripeInput!) {
      syncPaymentMethodFromStripe(input: $input) {
        paymentMethodSummary
        userErrors { message path }
      }
    }
  `)
);

export { SyncPaymentMethodFromStripeMutation };

export function useSyncPaymentMethodFromStripe() {
  return useMutation(SyncPaymentMethodFromStripeMutation);
}
